import { Button } from "components/Button/Button";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useRef, useState } from "react";
import {
  deleteClearoldfilesaccording,
  getSettings,
  ResetCache,
  sendSettings,
} from "./api";
import { trans } from "utils/helpers";
import { Loading } from "components/Loading/loading";

interface ChatSettingFormPropsType {}

export const ChatSettingForm = ({}: ChatSettingFormPropsType) => {
  const [resetForm, setResetForm] = useState(false);
  const [settings, setSettings] = useState<any>();
  const [loading, setLoading] = useState(false);

  async function formSubmit(event) {
    event.preventDefault();
    try {
      
      let data = {
        KeepFilesDuration: +event.target.keepfilesduration.value,
        TotalFilesSizeThreshold: +event.target.totalfilessizethreshold.value,
      };
      await sendSettings(data);
      setResetForm(true);
      getDataAsync()
    } catch (error) {}
  }

  async function getDataAsync() {
    setLoading(false);
    try {
      const res = await getSettings();
      setSettings(res.Data);
    } catch (error) {}
    setLoading(true);
  }
  async function ResetCacheAsync() {
    try {
      return await ResetCache();
    } catch (error) {}
  }
  const handleClearoldfilesaccordingabovesettings = async () => {
    try {
      await deleteClearoldfilesaccording();
    } catch (error) {}
  };

  useEffect(() => {
    getDataAsync();
  }, []);


  return (
    <form className="ChatSetting-form py-2" onSubmit={formSubmit}>
        {loading?
        <div className="card">
        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <div className="row aalign-items-end">
                <div className="col-6 col-lg-5">
                  <Textbox
                    required={true}
                    textboxType="number"
                    min={1}
                    textboxName="keepfilesduration"
                    resetForm={resetForm}
                    defaultValue={settings?.KeepFilesDuration}
                    labelText={`${trans("keepfilesduration")} (${trans(
                      "calendareventday"
                    )})`}
                    mode={"edit"}
                  />
                </div>
                <div className="col-6 col-lg-5">
                  <Textbox
                    required={true}
                    textboxType="number"
                    textboxName="totalfilessizethreshold"
                    min={1}
                    resetForm={resetForm}
                    defaultValue={settings?.TotalFilesSizeThreshold}
                    labelText={`${trans("totalfilessizethreshold")} (${trans(
                      "byte"
                    )})`}
                    mode={"edit"}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="d-flex  mt-4">
                    <Button
                      onClick={ResetCacheAsync}
                      value="clearcache"
                      btnType="primary"
                    />
                  </div>
                  <div className="d-flex  mt-4">
                    <Button
                      onClick={handleClearoldfilesaccordingabovesettings}
                      value="clearoldfilesaccordingabovesettings"
                      btnType="primary"
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4">
                <Button value="Save" btnType="submit" />
              </div>
            </div>
          </div>
        </div>
      </div>
        :<Loading/>}
      
    </form>
  );
};
